/**
 * Removes properties with falsy values from an object
 * @param {Object} object - The object to filter
 * @returns {Object} A new object containing only properties with truthy values
 */
const removeEmptyVals = (object) => {
    return Object.fromEntries(
        Object.entries(object).filter(([_, value]) => Boolean(value))
    )
}

/**
 * Deeply compares two objects for equality
 * @param {*} obj1 - First object to compare
 * @param {*} obj2 - Second object to compare
 * @returns {boolean} True if objects are equal, false otherwise
 */
const objsAreEqual = (obj1, obj2) => {
    //Check if both are the same reference
    if (obj1 === obj2) return true

    //Check if both are objects
    if (
        typeof obj1 !== 'object' ||
        obj1 === null ||
        typeof obj2 !== 'object' ||
        obj2 === null
    ) {
        return false
    }

    //Compare keys length
    const keys1 = Object.keys(obj1)
    const keys2 = Object.keys(obj2)
    if (keys1.length !== keys2.length) return false

    //Compare values recursively
    for (const key of keys1) {
        if (!keys2.includes(key)) return false
        if (!objsAreEqual(obj1[key], obj2[key])) return false
    }

    return true
}

/**
 * Updates a Vue reactive object with new data using Vue's $set method
 * @param {Object} ctx - Vue component context
 * @param {Object} oldData - Target reactive object to update
 * @param {Object} newData - Source object containing new values
 */
const setReactiveObject = (ctx, oldData, newData) => {
    Object.keys(newData).forEach((key) => {
        ctx.$set(oldData, key, newData[key])
    })
}

export { removeEmptyVals, objsAreEqual, setReactiveObject }
